module.exports = __webpack_public_path__ + "img/mo.c4f8f0c5.svg";